import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import jwtDecode from 'jwt-decode';

const LOCAL_STORAGE_USERNAME = 'username';
const LOCAL_STORAGE_USER_ID = 'user_id';
const LOCAL_STORAGE_USER_TOKEN = 'token_spp_dashboard';
const LOCAL_STORAGE_FIRSTNAME = 'firstname';
const LOCAL_STORAGE_LASTNAME = 'lastname';

export const roles = {
    GK: 'GK',
    COMPANY: 'COMPANY',
    BAM: 'BAM',
    CUSTOMER_REP: 'CUSTOMER_REP',
    ADMIN: 'ADMIN',
    SMS: 'SMS',
};

export function hasPermissionTo(permissions, user) {
    return true;
}

export function isLoggedIn(user) {
    return (user && user.token);
}

export function saveTokenToLocalStorage({token}) {
    localStorage.setItem(LOCAL_STORAGE_USER_TOKEN, token);
}

export function getTokenFromLocalStorage() {
    const authData = {token: localStorage.getItem(LOCAL_STORAGE_USER_TOKEN), };
    return (authData.token) ? authData : {};
}

export function logout() {
    localStorage.removeItem(LOCAL_STORAGE_USER_TOKEN);
}

export const isUserAuthenticated = (token) => {
    let decoded;
    try {
        decoded = jwtDecode(token);
    } catch (e) {
        console.error('failed to decode token', e);
    }

    if (decoded) {
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            console.warn('access token expired');
            return false;
        }
        return true;
    }
};
